import React from 'react';
import { Item } from '../../types';
import { useCart } from '../../contexts/CartContext';
import './ItemCard.css';

interface ItemCardProps {
  item: Item;
}

const ItemCard: React.FC<ItemCardProps> = ({ item }) => {
  const { addItem, isInCart } = useCart();

  const handleAddToCart = () => {
    addItem(item);
  };

  return (
    <div className="item-card">
      <div className="item-image">
        {/* Render product image using the `image` attribute. If it's missing, show a placeholder. */}
        {item.image ? (
          // If the image value looks like a relative path (starts with '/'), use it as-is.
          // Otherwise treat it as an absolute URL.
          <img
            className="item-img"
            src={item.image}
            alt={item.title}
            onError={(e) => {
              // Fallback to placeholder if the image fails to load
              const target = e.currentTarget as HTMLImageElement;
              target.onerror = null;
              target.src = '/static/img-placeholder.svg';
            }}
          />
        ) : (
          <div className="item-placeholder">
            <span className="item-icon">✨</span>
          </div>
        )}

        <div className="item-category">{item.category}</div>
      </div>
      
      <div className="item-content">
        <h3 className="item-title">{item.title}</h3>
        <p className="item-description">{item.description}</p>
        
        <div className="item-footer">
          <div className="item-price">{item.price.toFixed(2)}</div>
          <button 
            className={`btn ${isInCart(item.id) ? 'btn-success' : 'btn-primary'} item-add-btn`} 
            onClick={handleAddToCart}
          >
            {isInCart(item.id) ? 'בעגלה ✓' : 'הוסף לעגלה'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
